export * from './ActorFunctionFactoryTermLcase';
